import { render } from "./SectorsView.vue?vue&type=template&id=3aa32e5a&scoped=true"
import script from "./SectorsView.vue?vue&type=script&lang=js"
export * from "./SectorsView.vue?vue&type=script&lang=js"

import "./SectorsView.vue?vue&type=style&index=0&id=3aa32e5a&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa32e5a"]])

export default __exports__